// src/components/BoardPack/pages/area_chart.jsx

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { apiCall } from "@/api/apiCall";
import LoadingComponent from "@/components/common/LoadingComponent";
import ErrorState from "@/components/common/ErrorStateComponent";
import { useQueue } from "@/context/QueueContext";
import HeadingComponent from "@/components/BoardPack/components/shared/heading";
import AreaChart from "@/components/BoardPack/components/charts/AreaChart";

const AreaChartPage = ({ year = "", month = "", monthNumber = "", contract = "", page = null }) => {
    const navigate = useNavigate();
    const { enqueue } = useQueue();

    const [loading, setLoading] = useState(true);
    const [years, setYears] = useState([]);
    const [monthName, setMonthName] = useState("");
    const [error, setError] = useState(null);
    const [chartData, setChartData] = useState([]);
    const hasFetchedRef = useRef(false);

    useEffect(() => {
        // if (!year || !month || !contract) return;
        // if (hasFetchedRef.current) return;
        // hasFetchedRef.current = true;
        fetchData();
    }, [year, month, contract]);

    const fetchData = async () => {
        try {
            setLoading(true);
            setError(null);

            const params = {
                contract: page?.params?.contract || contract,
                year: year,
                month: month,
                value_type: page?.params?.value_type,
                device_onstreet: page?.params?.device_onstreet,
                average_calculation: page?.params?.average_calculation
            };

            const response = {
    "success": true,
    "errorCode": 0,
    "message": "data fetched successfully",
    "server": "KPI",
    "meta": {
        "contract": "0020016",
        "year": 2025,
        "years": [
            2023,
            2024,
            2025
        ],
        "month": "Apr",
        "value_type": 4,
        "average_calculation": "full_month"
    },
    "mdx": "SELECT { [Parking_Durations].[0], [Parking_Durations].[1], [Parking_Durations].[2], [Parking_Durations].[3], [Parking_Durations].[4], [Parking_Durations].[5], [Parking_Durations].[6], [Parking_Durations].[7], [Parking_Durations].[8], [Parking_Durations].[9], [Parking_Durations].[10], [Parking_Durations].[11], [Parking_Durations].[12], [Parking_Durations].[13], [Parking_Durations].[14], [Parking_Durations].[15], [Parking_Durations].[16], [Parking_Durations].[17], [Parking_Durations].[18], [Parking_Durations].[19], [Parking_Durations].[20], [Parking_Durations].[21], [Parking_Durations].[22], [Parking_Durations].[23] } ON COLUMNS, CROSSJOIN( { [Year].[2023], [Year].[2024], [Year].[2025] }, { [Months].[Apr] } ) ON ROWS FROM [OFF_STREET_PARKING_BY_PAYSTATUS] WHERE ( [LOCATION2].[0020016], [PAY_LOCATION].[All_Pay_Locations], [PAY_STATUS].[MEMBER], [Park_In_Period].[All_Period], [m_Parking].[Ticket_Count] )",
    "data": {
        "2023": {
            "Apr": {
                "0:00": "209",
                "1:00": "141",
                "2:00": "127",
                "3:00": "109",
                "4:00": "113",
                "5:00": "308",
                "6:00": "531",
                "7:00": "209",
                "8:00": "204",
                "9:00": "100",
                "10:00": "95",
                "11:00": "126",
                "12:00": "188",
                "13:00": "300",
                "14:00": "487",
                "15:00": "275",
                "16:00": "270",
                "17:00": "229",
                "18:00": "185",
                "19:00": "109",
                "20:00": "157",
                "21:00": "302",
                "22:00": "480",
                "23:00": "240"
            }
        },
        "2024": {
            "Apr": {
                "0:00": "276",
                "1:00": "123",
                "2:00": "108",
                "3:00": "104",
                "4:00": "98",
                "5:00": "226",
                "6:00": "512",
                "7:00": "300",
                "8:00": "268",
                "9:00": "121",
                "10:00": "119",
                "11:00": "128",
                "12:00": "168",
                "13:00": "247",
                "14:00": "551",
                "15:00": "417",
                "16:00": "385",
                "17:00": "225",
                "18:00": "191",
                "19:00": "136",
                "20:00": "188",
                "21:00": "245",
                "22:00": "491",
                "23:00": "331"
            }
        },
        "2025": {
            "Apr": {
                "0:00": "299",
                "1:00": "136",
                "2:00": "105",
                "3:00": "89",
                "4:00": "91",
                "5:00": "166",
                "6:00": "581",
                "7:00": "355",
                "8:00": "302",
                "9:00": "142",
                "10:00": "142",
                "11:00": "155",
                "12:00": "163",
                "13:00": "215",
                "14:00": "642",
                "15:00": "482",
                "16:00": "462",
                "17:00": "235",
                "18:00": "220",
                "19:00": "174",
                "20:00": "165",
                "21:00": "203",
                "22:00": "544",
                "23:00": "371"
            }
        }
    },
    "kpis": {
        "2023": {
            "ADT": "5,493",
            "Occupancy": "20.95%",
            "Parking Bays": "11,794"
        },
        "2024": {
            "ADT": "5,958",
            "Occupancy": "23.26%",
            "Parking Bays": "11,794"
        },
        "2025": {
            "ADT": "6,439",
            "Occupancy": "23.73%",
            "Parking Bays": "12,394"
        }
    }
};

            if (response?.success) {
                const processedData = processApiData(response);

                setYears(response?.meta?.years || []);
                setMonthName(response?.meta?.month || "");
                setChartData(processedData);
            } else {
                setError('Failed to fetch data');
            }
        } catch (err) {
            setError(err || 'An error occurred while fetching data');
            console.error('Error fetching data:', err);
        } finally {
            setLoading(false);
        }
    };

    const processApiData = (apiResponse) => {
        const allYearsData = apiResponse.data || {};
        const availableYears = Object.keys(allYearsData);

        const timeSlots = Array.from({ length: 24 }, (_, i) => `${i}:00`);
        const kpis = apiResponse.kpis || {};
        const monthName = apiResponse.meta?.month || "";

        return availableYears.map(yr => {
            const monthData = allYearsData[yr]?.[monthName] || {};

            const data = timeSlots.map(time => ({
                time,
                value: Number(monthData[time]?.replace(/,/g, '')) || 0
            }));

            const yearKpis = kpis[yr] || {};
            const metrics = Object.keys(yearKpis).map(key => {
                let val = yearKpis[key];

                if (val === "-" || val === null || val === undefined || val === "") {
                    val = 0;
                }

                return {
                    label: key,
                    value: val
                };
            });

            return { year: yr, data, metrics, monthName };
        });
    };

    if (loading) {
        return <LoadingComponent />;
    }

    if (error) {
        return <ErrorState error={error} onRetry={fetchData} />;
    }

    const title = page?.title;
    const subtitle = page?.subtitle;
    const yAxisLabel = page?.yAxisLabel;

    const totalCharts = chartData.length;
    const shouldCenterLast = totalCharts % 2 !== 0;

    return (
        <div className="min-h-screen p-4 md:p-6">
            <div className="flex flex-col gap-1 mb-1">
                {title && <HeadingComponent variant={"main"}>{title}</HeadingComponent>}
                {subtitle && <HeadingComponent variant={"sub"}>{subtitle}</HeadingComponent>}
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                {chartData.map((chartInfo, index) => {
                    const isLastChart = index === totalCharts - 1;
                    const isCenteredSingle = shouldCenterLast && isLastChart;

                    if (isCenteredSingle) {
                        return (
                            <div
                                key={`chart-${index}`}
                                className="lg:col-span-2 flex justify-center"
                                style={{ borderTop: "2px solid #ffd700" }}
                            >
                                <div style={{ width: "50%", minWidth: "320px" }}>
                                    <AreaChart
                                        data={chartInfo.data}
                                        metrics={chartInfo.metrics}
                                        mainTitle={`${chartInfo.year} - ${chartInfo.monthName}`}
                                        yAxisLabel={yAxisLabel || "MONTHLY DAILY VOLUMES"}
                                        tableRowLabel={`${chartInfo.year} - ${chartInfo.monthName}`}
                                        sidebarBgColor="var(--border-blue)"
                                        sidebarBorderColor="var(--border-blue)"
                                    />
                                </div>
                            </div>
                        );
                    }

                    return (
                        <div
                            key={`chart-${index}`}
                            style={{
                                borderRight: index % 2 === 0 ? "3.5px solid #ffd700" : "none",
                                borderBottom: "2px solid #ffd700",
                            }}
                        >
                            <AreaChart
                                data={chartInfo.data}
                                metrics={chartInfo.metrics}
                                mainTitle={`${chartInfo.year} - ${chartInfo.monthName}`}
                                yAxisLabel={yAxisLabel || "MONTHLY DAILY VOLUMES"}
                                tableRowLabel={`${chartInfo.year} - ${chartInfo.monthName}`}
                                sidebarBgColor="var(--border-blue)"
                                sidebarBorderColor="var(--border-blue)"
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AreaChartPage;